import React, { useState } from "react";
import {
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Grid,
    Tab,
    Tabs,
    Chip,
    Avatar,
    TextField,
    IconButton, InputAdornment, Checkbox
} from "@mui/material";
import AddIssues from "./AddIssue";
import EditIssues from "./EditIssue";
import RecentlyAdded from "./tabFiles/RecentlyAdded";
import styled from "@emotion/styled";
import AllIssues from "./tabFiles/AllIssues";
import SubbmittedByMe from "./tabFiles/SubbmittedByMe";

export default function IssueList() {
    const [value, setValue] = useState(0);
    const [selectedIssue, setSelectedIssue] = useState(null);
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [isCreateIssuePopupOpen, setIsCreateIssuePopupOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState([]);

    const issuesData = [
        {
            id: "ISX123",
            description: "Issue Regarding the traffic light...",
            contractor: "KYCC Construction P.",
            category: "Engineering",
            workflowStatus: "Open",
            currentStatus: "Open",
            createdDate: "2024-01-15T10:30:00.000Z",
            reportedDate: "2024-01-15T14:45:00.000Z",
            actionsBy: "Shanti Nautiyal",
            timeImpact: "23 Days",
        },
        {
            id: "ISX124",
            description: "Electrical wiring issue in building A",
            contractor: "ABC Electricians",
            category: "Electrical",
            workflowStatus: "In Progress",
            currentStatus: "Pending",
            createdDate: "2024-01-14T09:15:00.000Z",
            reportedDate: "2024-01-14T11:20:00.000Z",
            actionsBy: "Rajesh Kumar",
            timeImpact: "15 Days",
        },
        {
            id: "ISX125",
            description: "Plumbing leakage in washroom",
            contractor: "Prime Plumbing Co.",
            category: "Plumbing",
            workflowStatus: "Closed",
            currentStatus: "Resolved",
            createdDate: "2024-01-10T08:00:00.000Z",
            reportedDate: "2024-01-10T16:30:00.000Z",
            actionsBy: "Priya Sharma",
            timeImpact: "5 Days",
        },
        {
            id: "ISX126",
            description: "Structural crack in wall",
            contractor: "KYCC Construction P.",
            category: "Structural",
            workflowStatus: "Open",
            currentStatus: "Under Review",
            createdDate: "2024-01-12T13:20:00.000Z",
            reportedDate: "2024-01-13T09:45:00.000Z",
            actionsBy: "Amit Patel",
            timeImpact: "30 Days",
        },
        {
            id: "ISX127",
            description: "HVAC system not working",
            contractor: "Climate Control Inc.",
            category: "Mechanical",
            workflowStatus: "In Progress",
            currentStatus: "Work in Progress",
            createdDate: "2024-01-11T11:00:00.000Z",
            reportedDate: "2024-01-11T15:10:00.000Z",
            actionsBy: "Sneha Verma",
            timeImpact: "10 Days",
        },
        {
            id: "ISX128",
            description: "Paint peeling off walls",
            contractor: "ABC Electricians",
            category: "Civil",
            workflowStatus: "Open",
            currentStatus: "New",
            createdDate: "2024-01-09T07:30:00.000Z",
            reportedDate: "2024-01-09T12:25:00.000Z",
            actionsBy: "Rohit Singh",
            timeImpact: "7 Days",
        },
        {
            id: "ISX129",
            description: "Flooring tiles broken",
            contractor: "Prime Plumbing Co.",
            category: "Civil",
            workflowStatus: "Closed",
            currentStatus: "Completed",
            createdDate: "2024-01-08T14:15:00.000Z",
            reportedDate: "2024-01-08T17:40:00.000Z",
            actionsBy: "Neha Gupta",
            timeImpact: "3 Days",
        },
        {
            id: "ISX130",
            description: "Water supply interruption",
            contractor: "KYCC Construction P.",
            category: "Plumbing",
            workflowStatus: "In Progress",
            currentStatus: "Under Repair",
            createdDate: "2025-01-07T10:45:00.000Z",
            reportedDate: "2025-01-07T13:20:00.000Z",
            actionsBy: "Vikram Joshi",
            timeImpact: "12 Days",
        }
    ];

    const StyledTableCell = styled(TableCell)({
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "-0.6px",
        color: "#252C32",
        fontFamily: "Outfit, sans-serif",
    });



    const handleDeleteClick = () => {
        console.log("delete item")
    }

    const handleEditClick = (issueData) => {
        setSelectedIssue(issueData);
        setIsEditPopupOpen(true);
    };

    const handleCreateIssue = () => {
        setIsCreateIssuePopupOpen(true);
    };

    const handleCloseIssuePopup = () => {
        setIsCreateIssuePopupOpen(false);
    };
   
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const column = ["Issue ID", "Issue Description",
        "Contractor/Consultant", "Category", "Workflow Status",
        "Current Status", "Created Date", "Reported Date", "Actions Required By", "Time Impact"]

    return (
        <>
            <Grid container spacing={0} sx={{}} >

                {/* Header Section */}
                <Grid size={12} sx={{ bgcolor: "#F6F8F9", p: 2, pb: 0 }}>
                    <Grid size={12}>

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: "6px",
                                width: "100%"
                            }}
                        >
                            <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: { xs: "16px", sm: "18px", md: "18px" },
                                        lineHeight: "24px",
                                        color: "#252C32",
                                        fontFamily: "Outfit, sans-serif",
                                    }}
                                >
                                    Data sets
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: { xs: "18px", sm: "32px", md: "36px" },
                                        lineHeight: { xs: "16px", md: "48px" },
                                        color: "#252C32",
                                        fontFamily: "Outfit, sans-serif",
                                    }}
                                >
                                    Key Issues
                                </Typography>
                            </Box>
                            <Button
                                onClick={handleCreateIssue}
                                disableRipple
                                disableElevation
                                sx={{
                                    backgroundColor: "#00344C",
                                    width: "146px",
                                    height: "44px",
                                    borderRadius: "36px",
                                    color: "#FFFFFF",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "24px",
                                    fontFamily: "Outfit, sans-serif",
                                    textTransform: "none",
                                    letterSpacing: "-0.6%",
                                    "&:hover": { backgroundColor: "#00344C" },
                                }}
                            >
                                Create Issue
                            </Button>
                        </Box>

                    </Grid>
                    <Grid size={12}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: { xs: "12px", sm: "13px", md: "14px" },
                                lineHeight: "24px",
                                color: "#252C32",
                                fontFamily: "Outfit, sans-serif",
                                letterSpacing: "-0.6%"
                            }}
                        >
                            Find all your risk at one place so that user can find them at one place
                        </Typography>
                    </Grid>


                    <Grid size={12}>
                        <Box sx={{ mt: "31px", pb: 0, borderBottom: "1px solid #ECECEC", overflowX: "auto", whiteSpace: "nowrap" }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                TabIndicatorProps={{ style: { display: "none" } }}
                                variant="scrollable"
                                scrollButtons={false}
                            >
                                {["All Issues", "Recently Added", "Submitted by me"].map((label, index) => (
                                    <Tab
                                        key={index}
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 500,
                                                        fontSize: { xs: "12px", sm: "13px", md: "14px" },
                                                        lineHeight: "100%",
                                                        color: index === value ? "#0E73F6" : "#7E7E7E",
                                                        fontFamily: "Outfit, sans-serif",
                                                    }}
                                                >
                                                    {label}
                                                </Typography>

                                                {(index === 1 || index === 2) && (
                                                    <Chip
                                                        label={"2"}
                                                        sx={{
                                                            height: "20px",
                                                            width: "32px",
                                                            fontSize: { xs: "12px", md: "14px" },
                                                            fontWeight: 500,
                                                            lineHeight: 1,
                                                            backgroundColor: "#E5E9EB",
                                                            color: "#5F5F5F",
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        }
                                        sx={{
                                            textTransform: "none",
                                            minWidth: "auto",
                                            paddingBottom: "14px",
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                            mr: "30px",
                                            borderBottom: "2px solid transparent",
                                            "&.Mui-selected": {
                                                borderBottom: "2px solid #0E73F6",
                                                color: "#0E73F6",
                                            },
                                        }}
                                    />
                                ))}
                            </Tabs>
                        </Box>
                    </Grid>
                </Grid>
                <Grid size={12} sx={{ px: "24px" }}>
                    {value === 0 && (
                        <AllIssues
                            data={issuesData}
                            onEditClick={handleEditClick}
                        />
                    )}
                    {value === 1 && (
                        <RecentlyAdded
                            data={issuesData}
                            onEditClick={handleEditClick}
                        />
                    )}
                    {value === 2 && (
                        <SubbmittedByMe
                            data={issuesData}
                            onEditClick={handleEditClick}
                        />
                    )}
                </Grid>
                <AddIssues
                    open={isCreateIssuePopupOpen}
                    onClose={handleCloseIssuePopup}
                    setIsCreateIssuePopupOpen={setIsCreateIssuePopupOpen}
                />

                <EditIssues
                    open={isEditPopupOpen}
                    onClose={() => {
                        setIsEditPopupOpen(false);
                        setSelectedIssue(null);
                    }}
                    issueData={selectedIssue}
                />
            </Grid>

        </>
    );
}
